import { useState, useEffect } from "react";
import { useWorkspaceStore } from "@/store/useWorkspaceStore";
import type { StaffWithdrawQuery } from "../../types";

const BRAND = "#FF6B35";
const BRAND_BG = "#FFF3EE";

const WITHDRAW_OPTIONS = [
  { id: "weixin", title: "微信", icon: "ri-wechat-pay-fill", color: "#07C160" },
  { id: "alipay", title: "支付宝", icon: "ri-alipay-fill", color: "#1677FF" },
  { id: "bank", title: "银行卡", icon: "ri-bank-card-fill", color: "#F5222D" },
] as const;

type ExtractType = StaffWithdrawQuery["extract_type"];

interface Props {
  value: StaffWithdrawQuery;
  onChange: (val: StaffWithdrawQuery) => void;
}

export function WithdrawType({ value, onChange }: Props) {
  const [current, setCurrent] = useState<ExtractType>("weixin");
  const config = useWorkspaceStore((s) => s.config);

  const allowedTypes = config?.extract_type ?? ["1", "0"];
  const optionMap: Record<string, string> = { weixin: "1", alipay: "2", bank: "0" };
  const dataLists = WITHDRAW_OPTIONS.filter((opt) =>
    allowedTypes.includes(optionMap[opt.id]),
  );

  useEffect(() => {
    if (dataLists.length > 0 && !dataLists.some((d) => d.id === current)) {
      const first = dataLists[0];
      setCurrent(first.id);
      onChange({ ...value, extract_type: first.id });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataLists]);

  return (
    <div className="bg-white rounded-2xl p-4 space-y-4">
      <span className="text-base font-bold text-gray-900">提现至</span>

      {/* 方式列表 */}
      <div className="space-y-3">
        {dataLists.map((item) => {
          const isActive = current === item.id;
          return (
            <button
              key={item.id}
              onClick={() => {
                setCurrent(item.id);
                onChange({ ...value, extract_type: item.id as ExtractType });
              }}
              className={`w-full flex items-center justify-between px-4 py-3.5 rounded-xl transition-all active:scale-[0.98] ${
                isActive ? "border-2" : "border border-gray-100"
              }`}
              style={{
                borderColor: isActive ? BRAND : undefined,
                background: isActive ? `${BRAND_BG}40` : undefined,
              }}
            >
              <div className="flex items-center gap-3">
                <div
                  className="w-9 h-9 rounded-xl flex items-center justify-center"
                  style={{ background: `${item.color}15` }}
                >
                  <i className={`${item.icon} text-lg`} style={{ color: item.color }} />
                </div>
                <span className="text-sm font-medium text-gray-800">{item.title}</span>
              </div>

              {/* 自定义 radio */}
              <div
                className={`w-[18px] h-[18px] rounded-full flex items-center justify-center ${
                  isActive ? "" : "border-2 border-gray-200"
                }`}
                style={isActive ? { background: BRAND } : {}}
              >
                {isActive && <i className="ri-check-line text-white text-xs" />}
              </div>
            </button>
          );
        })}
      </div>

      <p className="text-xs text-gray-400">提交后后台审核成功即可到账</p>
    </div>
  );
}
